import { INCIDENT_TYPE } from '../constants'
import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from '../TagsClassification/constants'

import { CHANGE_INCIDENT_STATE_REQUEST_ASYNC } from './Header/constants'
import { FILTER_CHANGE, INCIDENT_REQUEST_ASYNC, PAGINATE_CHANGE } from './constants'

export default function () {
  const initialState = {
    incidentId: undefined,
    data: {},
    incidentLoader: false,
    loader: true,
    error: null,
    page: 1,
    alertsLoader: false,

    allFilters: {
      typeFilter: '',
      titleFilter: '',
      locationFilter: '',
      ipFilter: '',
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.SUCCESS: {
        return {
          ...state,
          data: {
            ...state.data,
            state: action.payload.newState,
            tags: [],
          },
          incidentLoader: false,
        }
      }
      case INCIDENT_REQUEST_ASYNC.INITIATE: {
        return {
          ...state,
          error: null,
          incidentLoader: true,
          loader: false,
          page: 1,
          incidentId: action.payload.incidentId,
        }
      }
      case INCIDENT_REQUEST_ASYNC.SUCCESS: {
        return {
          ...state,
          error: null,
          data: action.payload.data.report.incident,
          incidentLoader: false,
          loader: false,
          alertsLoader: false,
          filterOptions: action.payload.data.report.filterOptions,
        }
      }
      case INCIDENT_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
          incidentLoader: false,
          alertsLoader: false,
        }
      case INCIDENT_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          incidentId: undefined,
          allFilters: {
            typeFilter: '',
            titleFilter: '',
            locationFilter: '',
            ipFilter: '',
          },
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          alertsLoader: true,
        }
      case FILTER_CHANGE:
        return {
          ...state,
          alertsLoader: true,
          allFilters: {
            ...state.allFilters,
            [action.payload.filterType]: action.payload.newValue,
          },
        }
      case TAGS_REQUEST_ASYNC.SUCCESS: {
        if (
          action.payload.reportId &&
          action.payload.reportType &&
          action.payload.reportType === INCIDENT_TYPE.ATO &&
          action.payload.reportId === state.data.id
        ) {
          return {
            ...state,
            data: {
              ...state.data,
              tags: action.payload.data.selectedTags,
            },
          }
        } else return state
      }
      case EDIT_TAGS_REQUEST_ASYNC.SUCCESS: {
        if (action.payload.reportId === state.data.id) {
          return {
            ...state,
            data: {
              ...state.data,
              tags: action.payload.data,
            },
          }
        } else return state
      }
      default:
        return state
    }
  }
}
